module.exports = __webpack_public_path__ + "img/giftcodes-screens-2-new.8931cda5.png";